export default {
  userToken: '',
  userName: '',
  expiration: '',
};
